import axios from "axios";
import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import "./HandBooksPaytmPayment.scss";
import { url_301 } from "../../../../../../custom_utilities/api_services";
import saveOrderId from "../../../../../../redux/handbook_payment_gateway/action";
import {
  setOrderId,
  setPaytmDataInStore,
} from "../../../../../../redux/payment_gateway/action";
import {
  extractOrderId,
  savePendingHandbookOrderId,
} from "../../../../../../custom_utilities/paytm_payment/paytmHandbookHelpers";

const HandBooksPaytmPayment = (props) => {
  const { packageDetails, amount, paymentAction, setPaytmDataInStoreAction, userData } =
    props;
  const { name, mobile, email, address, user_id } = userData;

  const history = useHistory();
  const [isInitiating, setIsInitiating] = useState(false);

  const navigateToHandbookPaymentPage = (paytmData) => {
    const orderIdValue = extractOrderId(paytmData);
    if (!orderIdValue) return false;

    setPaytmDataInStoreAction(paytmData);
    savePendingHandbookOrderId(orderIdValue);
    history.push(
      `/handbook_payment_gateway?order_id=${encodeURIComponent(
        orderIdValue
      )}&await_payment=1`
    );
    return true;
  };

  const handleProfileData = () => {
    if (!name) {
      alert("You haven't update your name in your profile. Please update it");
      history.push("/user_edit_profile");
      return false;
    }
    if (!mobile) {
      alert("You haven't update your mobile number in your profile. Please update it");
      history.push("/user_edit_profile");
      return false;
    }
    if (!email) {
      alert("You haven't update your email in your profile. Please update it");
      history.push("/user_edit_profile");
      return false;
    }
    if (!address?.state) {
      alert("You haven't update your state in your profile. Please update it");
      history.push("/user_edit_profile");
      return false;
    }
    if (!address?.city) {
      alert("You haven't update your city in your profile. Please update it");
      history.push("/user_edit_profile");
      return false;
    }
    return true;
  };

  const initiateAndPay = async () => {
    const productId = packageDetails?.product_id || packageDetails?.p_id;
    if (!productId) return;

    const fromCartValue = packageDetails?.from_cart === true ? "true" : "false";

    const payload = {
      user_id,
      product_id: productId,
      price: packageDetails?.price || amount,
      discount: packageDetails?.discount || 0,
      coupon_discount: packageDetails?.coupon_discount || 0,
      shipping_charge: packageDetails?.shipping_charge || packageDetails?.shipping_charge || 0,
      total_price: packageDetails?.total_price || amount,
      from_cart: fromCartValue,
      coins_count: packageDetails?.coins_count || "0",
      is_referal: packageDetails?.is_referal || 0,
    };

    const response = await axios.post(url_301, payload);
    const responseData = response.data?.data || response.data;

    if (response.data?.status === 200) {
      const orderIdValue = extractOrderId(responseData);
      paymentAction(orderIdValue);
      navigateToHandbookPaymentPage(responseData);
    }
  };

  return (
    <button
      type="button"
      className="pay_now"
      onClick={async () => {
        if (isInitiating) return;
        if (!handleProfileData()) return;
        setIsInitiating(true);
        try {
          await initiateAndPay();
        } catch (err) {
        } finally {
          setIsInitiating(false);
        }
      }}
      disabled={isInitiating}
    >
      Confirm & Proceed
    </button>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.authToken,
  tokenType: state.auth.authType,
  userData: state.auth.user,
});

const mapDipatchToProps = (dispatch) => ({
  paymentAction: (payload) => {
    dispatch(saveOrderId.setOrderId(payload));
    dispatch(setOrderId(payload));
  },
  setPaytmDataInStoreAction: (payload) => {
    dispatch(setPaytmDataInStore(payload));
  },
});

export default connect(mapStateToProps, mapDipatchToProps)(HandBooksPaytmPayment);
